import { render, staticRenderFns } from "./SingleFeedbackDetail.vue?vue&type=template&id=630ca98a"
import script from "./SingleFeedbackDetail.vue?vue&type=script&lang=js"
export * from "./SingleFeedbackDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports